module.exports = __webpack_public_path__ + "static/images/open-external.787b263204ac838e1651ceca55263eba.svg";